<script>
export default {
    name: 'Display',
    props: {
        value: {
            type: [String, Number, Boolean, Object, Array, Function, Date],
            default: null
        },
        options: {
            type: [Object, Function],
            default: null
        },
        fallback: {
            type: [String, Number, Boolean, Object, Array, Function, Date],
            default: null
        },
        tooltip: {
            type: [String, Function],
            default: null
        },
        noTooltip: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayValue() {
            if (this._.isNil(this.value) && this.fallback) {
                return this.fallback;
            }
            return this.value;
        },
        optionsConfig() {
            if (this._.isFunction(this.options)) {
                return this.options(this.value);
            }

            if (this._.isObject(this.options)) {
                return this.options;
            }

            return {};
        },
        tooltipValue() {
            const tooltip = this.tooltip || this.getOption('tooltip');

            if (!tooltip) {
                return null;
            }

            if (this._.isFunction(tooltip)) {
                return tooltip(this.value);
            }

            return tooltip;
        },
        tooltipDisabled() {
            return this.noTooltip || !this.tooltipValue;
        }
    },
    methods: {
        getOption(key, defaultValue = false) {
            return this._.has(this.optionsConfig, key) ? this.optionsConfig[`${key}`] : defaultValue;
        }
    },
    render: () => ({})
};
</script>
